import { create } from 'zustand';
import createAlertSlice from './alertSlice';
import createNonProfitOrgSlice from './nonProfitOrgSlice';
import createNonProfitSlice from './nonProfitSlice';
import createNotificationSlice from './notificationSlice';
import createPageMetaSlice from './pageMetaSlice';
import createPostContributorDialogSlice from './postContributorDialogSlice';
import { createPostSlice } from './postSlice';
import createUserSlice from './userSlice';
import createVolunteeringSlice from './volunteeringSlice';

// import  from "./paypalTransactionsSlice";

const useStore = create((set, get) => ({
  ...createUserSlice(set, get),
  ...createPostSlice(set, get),
  ...createVolunteeringSlice(set, get),
  ...createNonProfitSlice(set, get),
  ...createNotificationSlice(set, get),
  ...createPageMetaSlice(set, get),
  ...createPostContributorDialogSlice(set, get),
  ...createAlertSlice(set, get),
  ...createNonProfitOrgSlice(set, get),
}));

export default useStore;
